import { render, staticRenderFns } from "./landmarkShop.vue?vue&type=template&id=57377740&scoped=true&"
import script from "./landmarkShop.vue?vue&type=script&lang=ts&"
export * from "./landmarkShop.vue?vue&type=script&lang=ts&"
import style0 from "./landmarkShop.vue?vue&type=style&index=0&id=57377740&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57377740",
  null
  
)

export default component.exports